import { ActionIcon, Textarea } from "@mantine/core";
import { IconSend } from "@tabler/icons-react";
import { useState } from "react";
import { useSelector } from "src/redux/hooks";

import styles from "./CommentInput.module.scss";

interface Props {
  onSend: (text: string) => void;
  isLoading: boolean;
  propsComment?: string;
  setPropsComment?: (comment: string) => void;
}

const CommentInput = ({
  onSend,
  isLoading,
  propsComment,
  setPropsComment,
}: Props) => {
  const uppercase = useSelector(state => state.preferencesSlice.uppercase);
  const [comment, setComment] = useState("");

  const onSubmit = () => {
    onSend(setPropsComment && propsComment ? propsComment : comment);
    setPropsComment ? setPropsComment("") : setComment("");
  };

  return (
    <Textarea
      px={10}
      value={propsComment ?? comment}
      onChange={e =>
        setPropsComment
          ? setPropsComment(e.currentTarget.value)
          : setComment(e.currentTarget.value)
      }
      placeholder="Type a comment"
      autosize={true}
      maxRows={3}
      classNames={{ input: styles.input }}
      styles={{
        input: {
          textTransform: uppercase ? "uppercase" : "none",
        },
      }}
      rightSection={
        <ActionIcon
          size="sm"
          mr={6}
          mt="auto"
          mb={6}
          variant="transparent"
          disabled={setPropsComment ? !propsComment : !comment}
          loading={isLoading}
          onClick={onSubmit}>
          <IconSend />
        </ActionIcon>
      }
    />
  );
};

export default CommentInput;
